import { Flex } from '@/components/Flex';
import { useRegionProvider } from '@/providers/RegionProvider';

import { RangeFilter } from '../RangeFilter';

export const PriceRangeFilter = () => {
  const {
    country: { currency },
  } = useRegionProvider();

  return (
    <Flex data-test-id='PriceRangeFilterFlex' flexBasis={600} flexShrink='0'>
      <RangeFilter
        attribute='price'
        data-test-id='PriceRangeFilterRangeFilter'
        label={currency}
      />
    </Flex>
  );
};

PriceRangeFilter.displayName = 'PriceRangeFilter';
